module.exports = __webpack_public_path__ + "img/greenClosed.78978dda.svg";